function shippingprice(zipcode, total) {
  var price = 0

  switch (zipcode) {
    // จังหวัดกรุงเทพ
    case '10110':
    case '10600':
    case '10510':
    case '10230':
    case '10900':
    case '10150':
    case '10210':
    case '10400':
    case '10300':
    case '10170':
    case '10140':
    case '10700':
    case '10240':
    case '10250':
    case '10220':
    case '10120':
    case '10160':
    case '10800':
    case '10260':
    case '10500':
    case '10330':
    case '10100':
    case '10200':
    case '10520':
    case '10310':
    case '10530':
    case '10550': // จังหวัดสมุทรปราการ
    case '10560':
    case '10540':
    case '10130':
    case '10290':
    case '10280':
    case '10270':
    case '12120': // จังหวัดปทุมธานี
    case '12110':
    case '12130':
    case '12000':
    case '12140':
    case '12150':
    case '12160':
    case '12170':
    case '11150': // จังหวัดนนทบุรี
    case '11130':
    case '11110':
    case '11140':
    case '11120':
    case '11000':
      price = 60
      break
    default:
      price = 70
  }

  return total >= 699 ? 0 : price
}

export { shippingprice }
